/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DepositClaimService = {

  async getBySOCode(code) {
    const requestScreenData = {
      url: "api/DepositClaim",
      top: "1",
      filter: `SalesOrderNo eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getDeposiClaimDetails(code) {
    const requestScreenData = {
      url: "api/DepositClaimDetail",
      filter: `SalesOrderNo eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getTermDueDate(TransactionDate, TermCalculation, TermDats) {

    const requestScreenData = {
      url: `api/TermDueDate/${TransactionDate}/${TermCalculation}/${TermDats}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async getCurrentAccountingPeriodCode() {
    const getCurrentAccountingPeriodCode = {
      url: "api/ARFactor",
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriodCode);
  },
  async getCurrentAccountingPeriod(periodCode) {
    const getCurrentAccountingPeriod = {
      url: "api/AccountingPeriod",
      filter: `Code eq '${periodCode}'`,
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriod);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async saveDeposiClaim(payload) {
    var url = "api/Save_DepositClaim";

    return await ApiService.post(url, payload);
  },
};

export { DepositClaimService };
